<button (click)="downloadPdf()">pobierz</button>
<div id="content">
  <header>
    <h1  >Gratulacje! To jest Twój wymarzony dom!</h1>
  </header>
  <main id="test">
    <div class="header">
      <p>Poniżej podsumowanie Twojej pracy z programem w formie raportu. Znajdziesz w nim komplet przydatnych informacji
        o kolorze, rodzaju tynku
        i potrzebnej ilości oraz adresy najbliższych sklepów, w których kupisz nasze produkty. Nie zapomnij podzielić
        się swoim pomysłem z rodziną i
        znajomymi - wyślij im maila lub udostępnij projekt w mediach społecznościowych.</p>
      <img src="{{project.projectImageFile}}" alt="">
      <div class="opis">
        <div class="opis-set">
          <h3><span  >Kolory tynku głównego:</span><em class="plastertype"><span>Miejski szyk</span></em></h3>
          <div class="colors">
            <div *ngFor="let color of project.selectedColors"><span
                [ngStyle]="{'background': color.rgb}"></span><em>{{color.code}}</em></div>
          </div>
        </div>
        <div *ngIf="project.selectedMosaic != null" class="opis-set">
          <h3><span  >Kolor tynku mozaikowego:</span></h3>
          <div class="colors">
            <div><img src="{{project.selectedMosaic.file}}"><em>{{project.selectedMosaic.code}}</em></div>
          </div>
        </div>
      </div>
    </div>
    <p   class="notice">Pamiętaj! Przedstawione w aplikacji palety barw Knauf pełnią jedynie funkcję
      informacyjną. Kolory mogą się
      różnić w zależności od ustawień monitora komputera lub ekranu tableta, czy smartfona, a także
      ustawień drukarki. Decyzję o wyborze koloru produktu należy podejmować na podstawie aktualnej palety barw Knauf
      dostępnej w formie firmowych materiałów informacyjnych (wzorniki, tablice). Zawarte
      tam próbki kolorystyczne wykonane są z autentycznych produktów. Wydawnictwa te dostępne są u partnerów handlowych
      oraz u przedstawicieli handlowych Knauf Sp. z o.o. Różnice w odcieniach
      kolorów konkretnych produktów a odpowiednikami tych kolorów zawartymi w niniejszym opracowaniu nie mogą stanowić
      podstawy do jakichkolwiek roszczeń w stosunku do firmy Knauf Sp. z o.o.</p>
    <hr>
    <div [ngClass]="{'both': project.selectedMosaic}">
      <h3><span  >Rodzaj tynku głównego:</span><em><span>{{plaster.name}}</span><span
             >{{plaster.plasterType | plasterType}}</span></em></h3>
      <img src="{{plaster.imageFile}}" alt="">
      <p >{{plaster.description}}</p>
      <p ><b  >Pamiętaj!</b> {{plaster.notice}}</p>
    </div>
    <div *ngIf="project.selectedMosaic" [ngClass]="{'both': project.selectedMosaic}">
      <h3><span >Rodzaj tynku mozaikowego:</span><em><span>Tynk Knauf MOSAIC</span></em></h3>
      <div>
        <img src="assets/photos/wiadro_mosaic.png" alt="">
        <p  >Tynk Mosaic produkowany jest na bazie wysokiej jakości kolorowych kruszyw, zatopionych w bezbarwnej
          żywicy
          silikonowo-akrylowej, dzięki temu pozwala uzyskać wyjątkowy efekt dekoracyjny, który doskonale podkreśli
          detale
          elewacji. Jest najbardziej odporny ze wszystkich tynków na działanie wody i uszkodzenia mechaniczne, dlatego
          wykorzystuje się go do zabezpieczenia cokołów i innych miejsc narażonych na zniszczenia oraz zabrudzenia, np.
          w
          strefie wejściowej do domu</p>
      </div>
    </div>
    <hr>
    <div class="required-set" [ngClass]="{'both': project.selectedMosaic}">
      <h3  >Potrzebna ilość tynku głównego:</h3>

      <ul>
        <li><span  >Granulacja tynku:</span> {{project.calculator.plaster.gramatura | gramatura}}</li>
        <li><span  >Pole powierzchni ocieplonej:</span> {{project.calculator.plaster.meters}} m<sup>2</sup></li>
        <li><span  >Potrzebujesz {{project.calculator.plaster.buckets}} opakowań</span> tynku {{plaster.shortName}}</li>
      </ul>
      <p class="notice"  > Podana ilość tynku stanowi jedynie wartość orientacyjną i jest sumą dla wszystkich kolorów
        tynku.
        Przed zakupem materiału skonsultuj otrzymany wynik z wykonawcą, którego zatrudniłeś do wykonania prac.</p>
    </div>
    <div *ngIf="project.selectedMosaic" [ngClass]="{'both': project.selectedMosaic}">
      <h3  >Potrzebna ilość tynku mozaikowego::</h3>

      <ul>
        <li><span  >Granulacja tynku:</span> {{project.calculator.mosaic.gramatura | gramatura:1}} </li>
        <li><span  >Pole powierzchni ocieplonej:</span> {{project.calculator.mosaic.meters}} m<sup>2</sup></li>
        <li><span  >Potrzebujesz {{project.calculator.mosaic.buckets}} opakowań</span> tynku MOSAIC</li>
      </ul>
      <p class="notice"  > Podana ilość tynku stanowi jedynie wartość orientacyjną. Przed zakupem materiału
        skonsultuj
        otrzymany wynik z wykonawcą, którego zatrudniłeś do wykonania prac.</p>
    </div>
    <hr>
    <h3>Jeśli potrzebujesz więcej szczegółów – zadzwoń do<br>
      Regionalnego Doradcy Technicznego KNAUF: {{project.closestSellers[0].region_phone}}</h3>
    <h3>Adresy punktów sprzedaży tynków elewacyjnych Knauf</h3>
    <ol>
      <li *ngFor="let seller of project.closestSellers"><b>{{seller.company}}</b> {{seller.city}} {{seller.zipcode}}, {{seller.address}}<br>
        <b>Kontakt:</b> {{seller.contacts[0].firstname}} {{seller.contacts[0].lastname}} tel: {{seller.contacts[0].phone}}<br>
        <b>Doradca regionalny KNAUF:</b> tel: {{seller.region_phone}}<br>
        <b>Strefa koloru:</b> <span *ngFor="let item of seller.palettes; let last=last">{{item}}<ng-container *ngIf="!last">, </ng-container></span>
      </li>
    </ol>
    <h3>Odwiedź „Strefę Koloru Knauf” w sklepach i hurtowniach budowlanych!</h3>
    <ul class="strefa">
      <li> Na dużych ekspozytorach zobaczysz z bliska próbki tynków w czterech paletach kolorystycznych</li>
      <li> Kupisz tynki na elewację Knauf – gotowe lub wymieszane na miejscu</li>
    </ul>
  </main>
</div>
